/**
 * Meta description kısaltma — TEK KAYNAK.
 *
 * Google ~155-160 karakterden sonrasını keser; 2026-09-30 denetiminde 112 public sayfanın açıklaması
 * 165+ karakterdi (en uzun 430), bir kısmı da `.slice(0, 158)` ile kelime ortasında kesiliyordu.
 * Kural: sınırı aşan metin, sınır içindeki son TAM CÜMLEDE biter; yoksa son liste öğesinde (virgül),
 * o da yoksa son kelimede kesilip nokta konur ("…" yok — yarım cümle izlenimi vermesin).
 */
export function metaAciklama(metin: string, max = 160): string {
  const t = metin.replace(/\s+/g, ' ').trim();
  if (t.length <= max) return t;
  const kesik = t.slice(0, max);
  // Son tam cümle (". " / "? " / "! " sonrası) — kısaltma noktası (Md. 7, vb.) cümle sonu sayılmasın diye
  // noktadan sonra büyük harf beklenir.
  const cumleSonlari = [...kesik.matchAll(/(?<!\b(?:Md|No|Dr|vb|bkz|m|Yön|St))[.!?](?=\s+[A-ZÇĞİÖŞÜ0-9])/g)].map((m) => m.index ?? -1);
  const son = cumleSonlari.length ? cumleSonlari[cumleSonlari.length - 1] : -1;
  if (son >= 80) return kesik.slice(0, son + 1);
  // Tam cümle yoksa liste öğesi sınırında (son virgül / noktalı virgül) bitir — "...ve." gibi yarım kalmasın.
  const liste = Math.max(kesik.lastIndexOf(', '), kesik.lastIndexOf('; '));
  if (liste >= 80) return `${kesik.slice(0, liste)}.`;
  const kelime = kesik.slice(0, kesik.lastIndexOf(' ')).replace(/[\s,;:—–-]+$/, '');
  return `${kelime}.`;
}
